import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { DayOffList } from './components/List'
import { DayOffCreatePage } from './components/Create'
import DayOffUpdate from './components/Update'
import { DetailDayOff } from './components/Detail'

const DayOffHrmModule: RouteObject = {
    path: 'dayoffs',
    element: <DayOffList pageType="hrm" />,
    errorElement: <ErrorPage status={500} />,
}

const DayOffEmployeeModule: RouteObject = {
    path: 'account/dayoffs',

    children: [
        {
            path: '',
            element: <DayOffList pageType="member" />,
        },
        {
            path: 'new',
            element: <DayOffCreatePage pageType="create" />,
        },
        {
            path: ':id/edit',
            element: <DayOffUpdate />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

const DayOffModule: RouteObject = {
    path: 'dayoffs',
    children: [
        {
            path: ':id',
            element: <DetailDayOff />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export { DayOffHrmModule, DayOffEmployeeModule, DayOffModule }
